/** Human display name for a sport/master code: "horse-racing" → "Horse Racing". */
export function displayName(code: string): string {
  return code
    .split(/[-_]/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
